import React from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

class Login extends React.Component {
  componentDidMount() {
    const { isAuthenticated } = this.props.session;

    if (isAuthenticated) {
      cookies.remove('jwt.payload', { path: '/' });
      cookies.remove('jwt.signature', { path: '/' });
    }

    const loginUrl = this.getLoginUrl();
    if (loginUrl) {
      window.location.href = loginUrl;
    }
  }

  getLoginUrl() {
    const { admin = false } = this.props;
    const userLoginUrl = process.env.REACT_APP_USER_LOGIN_URL;
    const adminLoginUrl = process.env.REACT_APP_ADMIN_LOGIN_URL;

    if (admin && adminLoginUrl) {
      return adminLoginUrl;
    }
    if (!admin && userLoginUrl) {
      return userLoginUrl;
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  session: state.session.session || {},
});

export default connect(mapStateToProps)(Login);
